import i18n from "../../i18n";
import { CLIENT_CONFIRM_FIELD_LABELS } from "../../helpers/clientFormValidate";
import { ORDER_CONFIRM_FIELD_LABELS } from "../../helpers/orderFormValidate";
import { getMcaEntityFormSchema } from "./mcaEntityFormRegistry";

const STATIC_LABELS_BY_ENTITY = {
  client: CLIENT_CONFIRM_FIELD_LABELS,
  order: ORDER_CONFIRM_FIELD_LABELS,
  provider: {
    code: "Code",
    shortName: "Short Name",
    name: "English Name",
    cname: "Chinese Name",
    insurerCode: "Insurer Code",
    tel: "Tel",
    fax: "Fax",
    email: "Email",
    address: "Address",
    isActive: "Active",
    ageType: "Age Type",
    remark: "Remark",
    productCategories: "Business Lines",
    website: "Website",
    paymentInfo: "Payment Information",
  },
};

const COMMON_FIELD_LABELS = {
  status: "Status",
  disposalStatus: "Disposal Status",
  email: "Email",
  phone: "Phone Number",
  phone2: "Phone Number 2",
  code: "Code",
  name: "English Name",
  cname: "Chinese Name",
  remark: "Remark",
  type: "Type",
  client: "Client",
  product: "Product",
  provider: "Provider",
  consultants: "Consultant",
  policyNumber: "Policy Number",
  paymentStatus: "Payment Status",
  agingStatus: "Aging Status",
  policyStatus: "Policy Status",
  renewalStatus: "Renewal Status",
  total: "Total",
  date: "Date",
  currency: "Currency",
  taxable: "Taxable",
  title: "Title",
  body: "Body",
  deadline: "Deadline",
  category: "Category",
  description: "Description",
  isActive: "Active",
  renewable: "Renewable",
};

const EXTRA_FIELD_LABELS = {
  "holdCover.date": "Hold Cover Date",
  "holdCover.remark": "Hold Cover Remark",
  "period.start": "Period Start",
  "period.end": "Period End",
  "payment.premium": "Premium",
  "payment.currency": "Currency",
  "payment.payMode": "Pay Mode",
  "payment.payStatus": "Pay Status",
  "payment.sumInsured": "Sum Insured",
  "payment.amount": "Amount",
  "payment.totalByCredit": "Total By Credit",
  "settlement.amount": "Settlement Amount",
  "settlement.paymentMethod": "Settlement Payment Method",
  "settlement.settleDate": "Settlement Date",
  "identity.hkid": "HKID",
  "identity.hkbr": "HKBR",
  "identity.passport": "Passport",
  "identity.staffNo": "Staff No.",
  marketingPreference: "Marketing Preference",
  "pep.isPep": "PEP",
  "pep.remark": "PEP Remark",
  professionalInvestor: "Professional Investor",
  knowledgeOfDerivatives: "Investor with Knowledge of Derivatives",
  parentCompany: "Parent Company",
  contactPerson: "Contact Person",
  incomeSources: "Source of Fund",
  aml: "AML",
  rpq: "RPQ",
  rpqStatus: "RPQ Status",
  eddFlagged: "EDD Flagged",
  inactiveAt: "Inactive Date",
  birthYear: "Year of Birth",
  disposedAt: "Disposed At",
  disposalStatus: "Disposal Status",
};

const FIELD_ZH_BY_PATH = {
  age: "年齡",
  annualIncome: "年收入",
  accountCloseDate: "帳戶關閉日期",
  inactiveAt: "停用日期",
  birthYear: "出生年份",
  disposedAt: "已處置日期",
  birthday: "出生日期",
  bussinessNature: "業務性質",
  cname: "中文名稱",
  code: "編號",
  consultants: "顧問",
  contactPerson: "聯絡人",
  currentAssets: "現有資產",
  currentAssetsCurrency: "現有資產貨幣",
  educationLevel: "教育程度",
  eddFlagged: "加強盡職審查標記",
  email: "郵箱",
  fax: "傳真",
  gender: "性別",
  givenName: "名字",
  id: "證件號碼",
  idDocExpiryDate: "證件到期日",
  "identity.hkbr": "商業登記證號碼",
  "identity.hkid": "香港身份證號碼",
  "identity.passport": "護照號碼",
  "identity.staffNo": "員工編號",
  identityExpired: "證件已過期",
  idIssueCountry: "證件簽發國家",
  idType: "證件類型",
  industry: "行業",
  isTransfer: "轉移",
  language: "語言",
  mailType: "郵寄類型",
  marketingPreference: "市場推廣偏好",
  maritalStatus: "婚姻狀況",
  name: "英文名稱",
  nationality: "國籍",
  occupation: "職業",
  parentCompany: "母公司",
  "pep.isPep": "政治公眾人物",
  "pep.remark": "PEP 備註",
  phone: "聯繫電話",
  phone2: "聯繫電話 2",
  piAnnualConfirmationDate: "PI 年度確認日期",
  piEffectiveDate: "PI 生效日期",
  piExpirationReminderDate: "PI 到期提醒日期",
  piTerminationDate: "PI 終止日期",
  placeOfBirth: "出生地",
  professionalInvestor: "專業投資者",
  knowledgeOfDerivatives: "具備衍生工具知識的投資者",
  remark: "備註",
  incomeSources: "資金來源",
  aml: "反洗錢",
  rpq: "風險取向問卷",
  rpqStatus: "RPQ 狀態",
  residentialCountry: "居住國家",
  salaryPayRatio: "薪金支付比例",
  salutation: "稱謂",
  status: "狀態",
  disposalStatus: "銷毀狀態",
  surname: "姓氏",
  type: "類型",
  vulnerable: "需要特別關注",
  yearlySalary: "年薪",
  aipAt: "AIP 日期",
  applicationMethod: "申請方式",
  basicOrder: "基本訂單",
  bidConsultants: "Bid 顧問",
  client: "客戶",
  commissionSetting: "佣金設定",
  createdBy: "創建人",
  dateBackOption: "倒填日期選項",
  debitNote: "發票",
  forceUncertainPayment: "強制不確定付款",
  fnaSignDate: "FNA 簽署日期",
  handlerBy: "處理人",
  handlerBy2: "處理人 2",
  insuredAge: "受保人年齡",
  isCertainPayment: "確定付款",
  isGI: "一般保險",
  isRider: "附加險",
  isSplit: "分拆",
  lapsedSurrenderDate: "失效/退保日期",
  mainlandChineseVisitor: "內地訪港旅客",
  mpfAccountType: "強積金帳戶類型",
  "payment.actualYearRate": "實際年率",
  "payment.creditCardLast4": "信用卡 (最後4位數字)",
  "payment.currency": "貨幣",
  "payment.initialPayment": "首期付款",
  "payment.initialPaymentCurrency": "首期付款貨幣",
  "payment.levy": "徵費",
  "payment.maturityDate": "到期日",
  "payment.payBy": "首期付款方式",
  "payment.payCount": "付款次數",
  "payment.payMode": "支付模式",
  "payment.payStatus": "繳費狀態",
  "payment.paymentTerm": "付款年期",
  "payment.paymentTermUntilAge": "付款年期 (直至年齡)",
  "payment.payUpDate": "付清日期",
  "payment.policyTerm": "保單年期",
  "payment.preliminaryDate": "預備日期",
  "payment.prePayment": "預付保費",
  "payment.prePaymentCurrency": "預付保費貨幣",
  "payment.premium": "保費",
  "payment.renewalPayBy": "續約付款方式",
  "payment.sumInsured": "保額",
  "payment.yearCommission": "年度佣金",
  "payment.yearConsultant1Commission": "顧問1年度佣金",
  "payment.yearConsultant2Commission": "顧問2年度佣金",
  "payment.yearConsultantCommission": "顧問年度佣金",
  "payment.yearPremium": "年度保費",
  "payment.yearRate": "年率",
  policyAckSignDate: "保單確認日期",
  policyCommenceDate: "保單生效日期",
  policyCoolingOffDate: "冷靜期截止日",
  policyDeliverDate: "保單交付日期",
  policyDeliverMethod: "保單交付方式",
  policyDeliverRemark: "保單交付備註",
  policyDocumentType: "保單形式",
  policyIssueDate: "保單簽發日期",
  policyNumber: "保單編號",
  policyRemark: "保單備註",
  policyReplacement: "保單替換",
  premiumFinancing: "保費融資",
  productCategory: "產品類別",
  productType: "產品類型",
  receivedDate: "收到日期",
  reinstateDate: "復效日期",
  renewalCount: "續保次數",
  renewalStatus: "續保狀態",
  signedBy: "簽署人",
  signedBy2: "簽署人 2",
  signedDate: "簽約日期",
  signedPlace: "簽署地點",
  submissionDate: "提交日期",
  taxable: "應課稅",
  totalWithdrawalAmount: "總提款金額",
  transferInEffectiveDate: "轉入生效日期",
  transferOutDate: "轉出日期",
  clientFixRate: "客戶固定費率",
  clientType: "客戶類型",
  commissionRate: "佣金率",
  confirmedAt: "確認時間",
  costTotal: "成本總額",
  discountAmount: "折扣金額",
  forceRenewal: "強制續保",
  agingStatus: "帳齡狀態",
  "holdCover.date": "暫保日期",
  "holdCover.remark": "暫保備註",
  insuredValue: "投保價值",
  mortgageeHirePurchaseName: "按揭/租購名稱",
  mortgageePostalAddress: "按揭郵寄地址",
  mortgagePostDate: "按揭郵寄日期",
  order: "訂單",
  "payment.adjustmentAmount": "調整金額",
  "payment.totalByCredit": "信用總額",
  "period.end": "期間結束",
  "period.start": "期間開始",
  policyDispatchedAt: "保單寄出時間",
  policyReceivedAt: "保單收到時間",
  profit: "利潤",
  providerCostReference: "保險公司成本參考",
  providerFixRate: "保險公司固定費率",
  refNo: "參考編號",
  settledAt: "結算時間",
  "settlement.amount": "結算金額",
  "settlement.paymentMethod": "結算付款方式",
  "settlement.remark": "結算備註",
  "settlement.settleDate": "結算日期",
  to: "收件人",
  address: "地址",
  aliasName: "別名",
  contacts: "相關人士",
  providerLogin: "保險公司登入",
  department: "部門",
  disableCreateOrder: "禁止創建訂單",
  emergencyContact: "緊急聯絡人",
  emergencyContactNo: "緊急聯絡電話",
  employmentDate: "入職日期",
  hkid: "香港身份證號碼",
  isConsultant: "顧問",
  mariage: "婚姻狀況",
  parent: "上級",
  personalEmail: "個人郵箱",
  referedBy: "推薦人",
  staffId: "員工編號",
  teams: "團隊",
  "termination.effectiveDate": "終止生效日期",
  "termination.lastEmploymentDate": "最後工作日",
  "termination.reason": "離職原因",
  "termination.resignDate": "辭職日期",
  userCategory: "用戶類別",
  userRole: "用戶角色",
  userType: "用戶類型",
  wallet: "錢包",
  workTitle: "職稱",
  "consultantInfo.iaApplyDate": "IA 申請日期",
  "consultantInfo.iaEffectiveDate": "IA 生效日期",
  "consultantInfo.iaFirstRegisterDate": "IA 首次註冊日期",
  "consultantInfo.iaNumber": "IA 編號",
  "consultantInfo.iaRole": "IA 角色",
  "consultantInfo.iaTerminationDate": "IA 終止日期",
  "consultantInfo.mpfaApplyDate": "MPFA 申請日期",
  "consultantInfo.mpfaEffectiveDate": "MPFA 生效日期",
  "consultantInfo.mpfaFirstRegisterDate": "MPFA 首次註冊日期",
  "consultantInfo.mpfaNumber": "MPFA 編號",
  "consultantInfo.mpfaRole": "MPFA 角色",
  "consultantInfo.mpfaTerminationDate": "MPFA 終止日期",
  "consultantInfo.overridingPlan": "Override 計劃",
  "consultantInfo.paymentMethods.accNumber": "銀行帳號",
  "consultantInfo.paymentMethods.bank": "銀行",
  "consultantInfo.paymentMethods.name": "帳戶名稱",
  "consultantInfo.paymentMethods.type": "付款方式類型",
  "consultantInfo.sfcApplyDate": "SFC 申請日期",
  "consultantInfo.sfcEffectiveDate": "SFC 生效日期",
  "consultantInfo.sfcFirstRegisterDate": "SFC 首次註冊日期",
  "consultantInfo.sfcNumber": "SFC 編號",
  "consultantInfo.sfcRole": "SFC 角色",
  body: "內容",
  createdBy: "創建人",
  maxRetakeCount: "最大重考次數",
  noLicenceNeed: "無需牌照",
  passingRate: "合格率",
  requiredLicenses: "所需牌照",
  requiredSfcLicences: "所需 SFC 牌照",
  startDate: "開始日期",
  targetRole: "目標角色",
  testDuration: "考試時長",
  activeTable: "生效表",
  ageType: "年齡類型",
  allowOffShore: "允許離岸",
  allowPreimumFinancing: "允許保費融資",
  allowPrepaid: "允許預付",
  inactiveSince: "停用日期",
  insuredWeeklyAge: "最低受保每週年齡",
  jurisdiction: "司法管轄區",
  minInitialCharge: "最低初始費用",
  minInsured: "最低保額",
  minPremium: "最低保費",
  otherName: "其他名稱",
  payModes: "付款模式",
  payTermMax: "最長付款年期",
  payTermMin: "最短付款年期",
  planCode: "計劃代碼",
  policyPledege: "保單質押",
  popularity: "熱門度",
  scname: "簡體中文名稱",
  shortName: "簡稱",
  insurerCode: "保險公司代碼",
  tel: "電話",
  website: "網站",
  paymentInfo: "付款資訊",
  allowQuoRequest: "允許報價申請",
  groupCode: "組別代碼",
  groupName: "組別名稱",
  investmentTransactions: "投資交易",
  mortgageeHirePurchase: "承按人 / 租購",
  "levySettings.ecLevy.formulaType": "EC 徵費公式類型",
  "levySettings.ecLevy.required": "EC 徵費必填",
  "levySettings.iaLevy.required": "IA 徵費必填",
  "levySettings.mibLevy.required": "MIB 徵費必填",
  renewable: "可續保",
};

const ENGLISH_ZH_FALLBACK = {
  Age: "年齡",
  "Annual Income": "年收入",
  "Date of Birth": "出生日期",
  "Bussiness Nature": "業務性質",
  "Chinese Name": "中文名稱",
  Code: "編號",
  Consultant: "顧問",
  "Contact Person": "聯絡人",
  "Current Assets": "現有資產",
  "Phone Number": "聯繫電話",
  "Phone Number 2": "聯繫電話 2",
  "English Name": "英文名稱",
  Remark: "備註",
  Status: "狀態",
  Type: "類型",
  Client: "客戶",
  Product: "產品",
  Provider: "保險公司",
  "Policy Number": "保單編號",
  "Payment Status": "付款狀態",
  "Aging Status": "帳齡狀態",
  "Policy Status": "保單狀態",
  "Renewal Status": "續保狀態",
  Total: "總數",
  Currency: "貨幣",
  Taxable: "應課稅",
  Title: "標題",
  Description: "描述",
  Category: "類別",
  Active: "活躍",
  Renewable: "可續保",
  Email: "郵箱",
  "Professional Investor": "專業投資者",
  "Parent Company": "母公司",
  "Short Name": "簡稱",
  "Insurer Code": "保險公司代碼",
  Tel: "電話",
  Fax: "傳真",
  Address: "地址",
  "Age Type": "年齡類型",
  "Payment Information": "付款資訊",
  Website: "網站",
  Premium: "保費",
  "Pay Mode": "支付模式",
  "Sum Insured": "保額",
  Amount: "金額",
  "Hold Cover Date": "暫保日期",
  "Hold Cover Remark": "暫保備註",
  "Period Start": "期間開始",
  "Period End": "期間結束",
  HKID: "香港身份證號碼",
  HKBR: "商業登記證號碼",
  Passport: "護照號碼",
  "Staff No.": "員工編號",
  PEP: "政治公眾人物",
  "PEP Remark": "PEP 備註",
};

const humanizeFieldPath = (fieldPath) =>
  fieldPath
    .split(".")
    .map((part) =>
      part
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase())
    )
    .join(" / ");

export const extractSchemaFieldLabels = (schema) => {
  const labels = {};
  (schema?.layout?.fields ?? []).forEach((field) => {
    const name = field?.name;
    const label = field?.props?.label;
    if (name && typeof label === "string" && label.trim()) {
      labels[name] = label.trim();
    }
  });
  return labels;
};

const resolveEnglishLabel = (entityKey, fieldPath, schemaLabels) => {
  const staticLabels = STATIC_LABELS_BY_ENTITY[entityKey] ?? {};
  return (
    staticLabels[fieldPath] ??
    schemaLabels[fieldPath] ??
    EXTRA_FIELD_LABELS[fieldPath] ??
    COMMON_FIELD_LABELS[fieldPath] ??
    humanizeFieldPath(fieldPath)
  );
};

const zhT = () => i18n.getFixedT("zh-tw");

const resolveChineseLabel = (fieldPath, english) => {
  if (FIELD_ZH_BY_PATH[fieldPath]) return FIELD_ZH_BY_PATH[fieldPath];

  const t = zhT();
  const candidates = [
    english,
    humanizeFieldPath(fieldPath),
    COMMON_FIELD_LABELS[fieldPath],
    EXTRA_FIELD_LABELS[fieldPath],
  ].filter(Boolean);

  for (const candidate of candidates) {
    const translated = t(candidate);
    if (translated && translated !== candidate) return translated;
    if (ENGLISH_ZH_FALLBACK[candidate]) return ENGLISH_ZH_FALLBACK[candidate];
  }

  const leaf = fieldPath.split(".").pop();
  if (FIELD_ZH_BY_PATH[leaf]) return FIELD_ZH_BY_PATH[leaf];

  return ENGLISH_ZH_FALLBACK[english] ?? "—";
};

export const formatBilingualWatchFieldLabel = (english, chinese) => {
  if (chinese && chinese !== "—") return `${english} / ${chinese}`;
  return english;
};

export const getWatchFieldSelectOption = (entityKey, fieldPath) => {
  if (!fieldPath) return null;
  const [info] = getMcaWatchFieldExplanations(entityKey, [fieldPath]);
  if (!info) return { value: fieldPath, label: fieldPath };
  return {
    value: info.field,
    label: formatBilingualWatchFieldLabel(info.english, info.chinese),
  };
};

export const buildWatchFieldSelectOptions = (entityKey, fieldPaths = []) =>
  getMcaWatchFieldExplanations(entityKey, fieldPaths).map(({ field, english, chinese }) => ({
    value: field,
    label: formatBilingualWatchFieldLabel(english, chinese),
  }));

export const getMcaWatchFieldExplanations = (entityKey, fieldPaths = []) => {
  const schema = entityKey ? getMcaEntityFormSchema(entityKey, (key) => key) : null;
  const schemaLabels = extractSchemaFieldLabels(schema);

  return [...fieldPaths]
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b))
    .map((field) => {
      const english = resolveEnglishLabel(entityKey, field, schemaLabels);
      return {
        field,
        english,
        chinese: resolveChineseLabel(field, english),
      };
    });
};
